import { render, staticRenderFns } from "./addFeePrintSpec.vue?vue&type=template&id=a51724a2"
import script from "./addFeePrintSpec.vue?vue&type=script&lang=js"
export * from "./addFeePrintSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports